import {forwardRef} from 'react'
import {AlertTriangleIcon, CheckIcon} from '@components/ui/icon'
import {cn} from '@utilities/helpers.ts'

export type StepStatus = 'active' | 'inactive' | 'completed' | 'error'
export interface StepCardProps {
    number: number
    status: StepStatus
    title: string
}

const stepCardNumberVariants: Record<StepStatus, string> = {
    active: 'bg-primary-600 text-md font-bold text-white shadow-md',
    completed: 'bg-success-50 text-success-600',
    error: 'bg-danger-600 text-white',
    inactive: 'bg-neutral-100 text-neutral-500'
}

const stepCardTitleVariants: Record<StepStatus, string> = {
    active: '',
    completed: 'text-neutral-700',
    error: '',
    inactive: 'text-neutral-500'
}

export const StepCard = forwardRef<HTMLDivElement, StepCardProps>(({number, status, title}, ref) => {
    return (
        <div
            ref={ref}
            className={cn('flex items-center p-4 gap-2', status === 'active' ? 'bg-transparent border-none' : '')}
        >
            <div className={cn('flex items-center justify-center rounded-full size-9', stepCardNumberVariants[status])}>
                {status == 'completed' ? (
                    <CheckIcon size={20} />
                ) : status == 'error' ? (
                    <AlertTriangleIcon size={20} />
                ) : (
                    number
                )}
            </div>
            <h1 className={cn('text-sm font-semibold', stepCardTitleVariants[status])}>{title}</h1>
        </div>
    )
})
